module.exports = __webpack_public_path__ + "static/media/loader.3e54c692.gif";